module.exports = __webpack_public_path__ + "static/img/pdf_icon@3x.eaf0efb3.png";